export const API_ERROR_CODE_I18N_REASON_PLATFORM_SHARED: Record<string, string> = {
  access_denied: "common.errors.apiCodeReasons.platformShared.accessDenied",
  access_forbidden: "common.errors.apiCodeReasons.platformShared.accessForbidden",
  access_level_invalid: "common.errors.apiCodeReasons.platformShared.accessLevelInvalid",
  actor_user_id_required: "common.errors.apiCodeReasons.platformShared.actorUserIdRequired",
  admin_required: "common.errors.apiCodeReasons.platformShared.adminRequired",
  already_archived: "common.errors.apiCodeReasons.platformShared.alreadyArchived",
  already_exists: "common.errors.apiCodeReasons.platformShared.alreadyExists",
  allocation_conflict: "common.errors.apiCodeReasons.platformShared.allocationConflict",
  archived: "common.errors.apiCodeReasons.platformShared.archived",
  asset_download_failed: "common.errors.apiCodeReasons.platformShared.assetDownloadFailed",
  asset_remediation_unavailable:
    "common.errors.apiCodeReasons.platformShared.assetRemediationUnavailable",
  binding_invalid: "common.errors.apiCodeReasons.platformShared.bindingInvalid",
  code_sequence_exhausted: "common.errors.apiCodeReasons.platformShared.codeSequenceExhausted",
  configuration_missing: "common.errors.apiCodeReasons.platformShared.configurationMissing",
  current_user_disable_forbidden:
    "common.errors.apiCodeReasons.platformShared.currentUserDisableForbidden",
  current_user_kickout_forbidden:
    "common.errors.apiCodeReasons.platformShared.currentUserKickoutForbidden",
  current_user_password_reset_forbidden:
    "common.errors.apiCodeReasons.platformShared.currentUserPasswordResetForbidden",
  data_contract_invalid: "common.errors.apiCodeReasons.platformShared.dataContractInvalid",
  data_invalid: "common.errors.apiCodeReasons.platformShared.dataInvalid",
  database_not_ready: "common.errors.apiCodeReasons.platformShared.databaseNotReady",
  datastore_unavailable: "common.errors.apiCodeReasons.platformShared.datastoreUnavailable",
  delete_blocked: "common.errors.apiCodeReasons.platformShared.deleteBlocked",
  delete_in_use: "common.errors.apiCodeReasons.platformShared.deleteInUse",
  disabled: "common.errors.apiCodeReasons.platformShared.disabled",
  duplicate_code: "common.errors.apiCodeReasons.platformShared.duplicateCode",
  duplicate_name: "common.errors.apiCodeReasons.platformShared.duplicateName",
  duplicate_source: "common.errors.apiCodeReasons.platformShared.duplicateSource",
  duplicate_user_id: "common.errors.apiCodeReasons.platformShared.duplicateUserId",
  edit_requires_draft: "common.errors.apiCodeReasons.platformShared.editRequiresDraft",
  error: "common.errors.apiCodeReasons.platformShared.error",
  execution_admin_required: "common.errors.apiCodeReasons.platformShared.executionAdminRequired",
  expired: "common.errors.apiCodeReasons.platformShared.expired",
  failed: "common.errors.apiCodeReasons.platformShared.failed",
  field_required: "common.errors.apiCodeReasons.platformShared.fieldRequired",
  file_required: "common.errors.apiCodeReasons.platformShared.fileRequired",
  file_too_large: "common.errors.apiCodeReasons.platformShared.fileTooLarge",
  filter_invalid: "common.errors.apiCodeReasons.platformShared.filterInvalid",
  grant_already_exists: "common.errors.apiCodeReasons.platformShared.grantAlreadyExists",
  grant_not_found: "common.errors.apiCodeReasons.platformShared.grantNotFound",
  grant_update_payload_required:
    "common.errors.apiCodeReasons.platformShared.grantUpdatePayloadRequired",
  grantee_type_invalid: "common.errors.apiCodeReasons.platformShared.granteeTypeInvalid",
  grantee_value_required: "common.errors.apiCodeReasons.platformShared.granteeValueRequired",
  has_published_tools: "common.errors.apiCodeReasons.platformShared.hasPublishedTools",
  identity_admin_required: "common.errors.apiCodeReasons.platformShared.identityAdminRequired",
  ids_required: "common.errors.apiCodeReasons.platformShared.idsRequired",
  internal_actor_user_id_required:
    "common.errors.apiCodeReasons.platformShared.internalActorUserIdRequired",
  internal_token_missing: "common.errors.apiCodeReasons.platformShared.internalTokenMissing",
  invalid_app_session: "common.errors.apiCodeReasons.platformShared.invalidAppSession",
  invalid_choice: "common.errors.apiCodeReasons.platformShared.invalidChoice",
  invalid_format: "common.errors.apiCodeReasons.platformShared.invalidFormat",
  invalid_roles: "common.errors.apiCodeReasons.platformShared.invalidRoles",
  "request.invalid_format": "common.errors.apiCodeReasons.platformShared.invalidFormat",
  invalid_internal_lookup_secret:
    "common.errors.apiCodeReasons.platformShared.invalidInternalLookupSecret",
  invalid_internal_token: "common.errors.apiCodeReasons.platformShared.invalidInternalToken",
  invalid_response: "common.errors.apiCodeReasons.platformShared.invalidResponse",
  invalid_sso_user_payload: "common.errors.apiCodeReasons.platformShared.invalidSsoUserPayload",
  invalid_token: "common.errors.apiCodeReasons.platformShared.invalidToken",
  invalid_user_payload: "common.errors.apiCodeReasons.platformShared.invalidUserPayload",
  key_required: "common.errors.apiCodeReasons.platformShared.keyRequired",
  loki_invalid_response: "common.errors.apiCodeReasons.platformShared.lokiInvalidResponse",
  loki_not_configured: "common.errors.apiCodeReasons.platformShared.lokiNotConfigured",
  loki_unavailable: "common.errors.apiCodeReasons.platformShared.lokiUnavailable",
  mapping_versions_must_differ:
    "common.errors.apiCodeReasons.platformShared.mappingVersionsMustDiffer",
  missing: "common.errors.apiCodeReasons.platformShared.missing",
  missing_asset_reference: "common.errors.apiCodeReasons.platformShared.missingAssetReference",
  missing_bearer_token: "common.errors.apiCodeReasons.platformShared.missingBearerToken",
  nested_impersonation_forbidden:
    "common.errors.apiCodeReasons.platformShared.nestedImpersonationForbidden",
  notice_content_required: "common.errors.apiCodeReasons.platformShared.noticeContentRequired",
  notice_title_required: "common.errors.apiCodeReasons.platformShared.noticeTitleRequired",
  not_activatable: "common.errors.apiCodeReasons.platformShared.notActivatable",
  not_active_or_not_found: "common.errors.apiCodeReasons.platformShared.notActiveOrNotFound",
  not_finished: "common.errors.apiCodeReasons.platformShared.notFinished",
  not_found: "common.errors.apiCodeReasons.platformShared.notFound",
  not_in_framework: "common.errors.apiCodeReasons.platformShared.notInFramework",
  not_readable: "common.errors.apiCodeReasons.platformShared.notReadable",
  not_writable: "common.errors.apiCodeReasons.platformShared.notWritable",
  operator_id_required_for_asset_upload:
    "common.errors.apiCodeReasons.platformShared.operatorIdRequiredForAssetUpload",
  parent_scheme_missing: "common.errors.apiCodeReasons.platformShared.parentSchemeMissing",
  policy_already_exists: "common.errors.apiCodeReasons.platformShared.policyAlreadyExists",
  policy_not_found: "common.errors.apiCodeReasons.platformShared.policyNotFound",
  policy_update_payload_required:
    "common.errors.apiCodeReasons.platformShared.policyUpdatePayloadRequired",
  preflight_failed: "common.errors.apiCodeReasons.platformShared.preflightFailed",
  ref_required: "common.errors.apiCodeReasons.platformShared.refRequired",
  reference_contract_invalid:
    "common.errors.apiCodeReasons.platformShared.referenceContractInvalid",
  request_id_missing: "common.errors.apiCodeReasons.platformShared.requestIdMissing",
  required_field: "common.errors.apiCodeReasons.platformShared.requiredField",
  resource_type_required: "common.errors.apiCodeReasons.platformShared.resourceTypeRequired",
  target_ref_not_allowed: "common.errors.apiCodeReasons.platformShared.targetRefNotAllowed",
  target_ref_required: "common.errors.apiCodeReasons.platformShared.targetRefRequired",
  s3_temp_credentials_audit_persistence_failed:
    "common.errors.apiCodeReasons.platformShared.s3TempCredentialsAuditPersistenceFailed",
  s3_temp_credentials_request_failed:
    "common.errors.apiCodeReasons.platformShared.s3TempCredentialsRequestFailed",
  s3_temp_credentials_upstream_invalid_response:
    "common.errors.apiCodeReasons.platformShared.s3TempCredentialsUpstreamInvalidResponse",
  scope_forbidden: "common.errors.apiCodeReasons.platformShared.scopeForbidden",
  scope_invalid: "common.errors.apiCodeReasons.platformShared.scopeInvalid",
  scope_not_found: "common.errors.apiCodeReasons.platformShared.scopeNotFound",
  scope_required: "common.errors.apiCodeReasons.platformShared.scopeRequired",
  scope_type_invalid: "common.errors.apiCodeReasons.platformShared.scopeTypeInvalid",
  scope_value_invalid: "common.errors.apiCodeReasons.platformShared.scopeValueInvalid",
  service_required: "common.errors.apiCodeReasons.platformShared.serviceRequired",
  share_contract_invalid: "common.errors.apiCodeReasons.platformShared.shareContractInvalid",
  sso_integration_disabled: "common.errors.apiCodeReasons.platformShared.ssoIntegrationDisabled",
  sso_unavailable: "common.errors.apiCodeReasons.platformShared.ssoUnavailable",
  storage_mapping_incomplete:
    "common.errors.apiCodeReasons.platformShared.storageMappingIncomplete",
  temp_credentials_backend_invalid:
    "common.errors.apiCodeReasons.platformShared.tempCredentialsBackendInvalid",
  tree_invalid: "common.errors.apiCodeReasons.platformShared.treeInvalid",
  title_required: "common.errors.apiCodeReasons.platformShared.titleRequired",
  type_required: "common.errors.apiCodeReasons.platformShared.typeRequired",
  unavailable: "common.errors.apiCodeReasons.platformShared.unavailable",
  unsupported_app_key: "common.errors.apiCodeReasons.platformShared.unsupportedAppKey",
  unsupported_type: "common.errors.apiCodeReasons.platformShared.unsupportedType",
  user_id_required: "common.errors.apiCodeReasons.platformShared.userIdRequired",
  worker_identity_invalid: "common.errors.apiCodeReasons.platformShared.workerIdentityInvalid",
  write_forbidden: "common.errors.apiCodeReasons.platformShared.writeForbidden",
  write_policy_invalid: "common.errors.apiCodeReasons.platformShared.writePolicyInvalid",
  username_required: "common.errors.apiCodeReasons.platformShared.usernameRequired",
  invalid_status: "common.errors.apiCodeReasons.platformShared.statusInvalid",
  number_allocation_invalid: "common.errors.apiCodeReasons.platformShared.allocationInvalid",
  number_sequence_exhausted: "common.errors.apiCodeReasons.platformShared.sequenceExhausted",
  owner_user_id_required: "common.errors.apiCodeReasons.platformShared.userIdRequired",
};
